module.exports = {

  wrapStringInHTML: function(str) {
    return {__html: str }
  }

}